import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

// Enabling customProperties will also generate a css variable for each theme color, which you can then use in your components' blocks.
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // Since the Organisation will have their own color scheme, 
    // setting colors here is kinda useless 
    themes: {
      light: {
        primary: '#131448',
        secondary: '#EB3995',
        accent: '#5ACAEC',
      },
      dark: {
        primary: '#131448',
        secondary: '#EB3995',
        accent: '#5ACAEC',
      },
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdiSvg',
  }
});
